<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12" class="px-0">
        <h5 class="mb-0">{{ $t("Контрагент сверкаси")}}</h5>
      </b-col>
      <div class="my-1 column3">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </div>
      <div class="my-1 column3">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </div>
      <div class="my-1 column3">
        <label>Склад</label>
        <v-select
          class="form-control-sm md-input"
          :options="skladlist"
          :clearable="false"
          v-model="datas.sklad_id"
          :disabled="skladhave"
          :reduce="name => name.id"
          label="name"
        >
        <template #search="{ attributes, events }">
          <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
            aria-activedescendant="null"
          />
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            <em
              ><b>{{ search }}</b></em
            >
            {{ $t("бўйича маьлумот йўқ") }}
          </template>
          <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
        </template>
        </v-select>
      </div>
      <div class="my-1 column3">
        <label for="">Контрагент</label>
        <v-select
          :clearable="false"
          class="form-control-sm"
          :options="kontragentlist"
          v-model="datas.kontragent_id"
          :reduce="name => name.id"
          label="name"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"></span>
            <a
              href="javascript:void(0)"
              class="modallist"
              v-b-modal.modal-kontragentlist
            >
              <b-icon icon="three-dots"></b-icon>
            </a>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em
                ><b>{{ search }}</b></em
              >
              {{ $t("бўйича маьлумот йўқ") }}
              <button
                type="button"
                @click="kontragent.name = search"
                v-b-modal.modal-kontragent
              >
                +
              </button>
            </template>
            <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <!-- <div class="my-1 column2-5">
        <label for="">{{$t('Тип оплата')}}</label>
        <v-select
          :clearable="false"
          class="form-control-sm"
          :options="pricelist"
          v-model="datas.price_type"
          :reduce="name => name.id"
          label="name"
        >
        </v-select>
      </div> -->
      <div class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          Кўриш
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
      </div>
      <div class="limiter" id="tableId">
        <div class="container-table100">
          <div class="wrap-table100">
            <div class="table100 ver1 m-b-110" style="padding-top:58px!important">
              <div class="table100-head">
                <table>
                  <thead>
                    <tr class="row100 head">
                      <th class="cell100 column1" rowspan="2">#</th>
                      <th class="cell100" rowspan="2">{{ $t("Номи") }}</th>
                      <th class="cell100 column3" rowspan="2">{{ $t("Вақт") }}</th>
                      <th class="cell100 column3" rowspan="2">Комментарий</th>
                      <th class="cell100 column3" colspan="2">Сўм</th>
                      <th class="cell100 column3" colspan="2">Доллар</th>
                    </tr>
                    <tr class="row100 head">
                      <th class="cell100 column2">{{ $t("Кирим") }}</th>
                      <th class="cell100 column2">{{ $t("Расход") }}</th>
                      <th class="cell100 column2">{{ $t("Кирим") }}</th>
                      <th class="cell100 column2">{{ $t("Расход") }}</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td colspan="4" class="cell100">
                      {{ $t("Бошланғич қолдиқ") }}
                    </td>
                    <td class="cell100 column2 kol">
                      <span
                        :class="{ red: parseInt(results.begin_total) < 0 }" v-if="results.begin_total!=0"
                        >{{ results.begin_total|numFormats }}</span
                      >
                    </td>
                    <td class="cell100 column2 kol"></td>
                    <td class="cell100 column2 kol">
                      <span
                        :class="{ red: parseInt(results.begin_total_dollar) < 0 }" v-if="results.begin_total_dollar!=0"
                        >{{ results.begin_total_dollar|numFormats }}</span
                      >
                    </td>
                    <td class="cell100 column2 kol"></td>
                  </tr>
                </table>
              </div>
              <div class="table100-body sverka js-pscroll">
                <table>
                  <tbody>
                    <tr
                      class="row100 body"
                      v-for="(item, index) in results.data"
                      :key="index"
                      @click="Clicked(item)"
                    >
                   
                      <td class="cell100 column1">
                        {{ index + 1 }}
                      </td>
                      <td class="cell100">
                          {{ $t(item.doc_type) }} № {{ item.doc_id }}
                      </td>
                      <td class="cell100 column3">
                          {{ Dates(item.datetime) }}
                      </td>
                      <td class="cell100 column3">
                        {{ item.comment}}
                    </td>
                      <td class="cell100 column2 kol">
                        <span v-if="item.kirim_summa!=0">
                          {{ item.kirim_summa | numFormats }}
                          </span>
                      </td>
                      <td class="cell100 column2 kol">
                                                <span v-if="item.chiqim_summa!=0">
                          {{ item.chiqim_summa | numFormats }}
                          </span>
                      </td>
                      <td class="cell100 column2 kol">
                        <span v-if="item.kirim_summa_dollar!=0">
                        {{ item.kirim_summa_dollar | numFormats }}
                        </span>
                    </td>
                      <td class="cell100 column2 kol">
                        <span v-if="item.chiqim_summa_dollar!=0">
                        {{ item.chiqim_summa_dollar | numFormats }}
                        </span>
                    </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table100-body summatable1">
                <table>
                  <tr v-if="results.summ">
                    <td class="cell100" colspan="3">{{ $t("Жами") }}</td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.summ.kirim_cash>0">
                        {{
                        results.summ.kirim_cash | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.summ.chiqim_cash">{{
                        results.summ.chiqim_cash | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.summ.kirim_cash_dollar">{{
                        results.summ.kirim_cash_dollar | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol">
                      <span v-if="results.summ.chiqim_cash_dollar">{{
                        results.summ.chiqim_cash_dollar | numFormats
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="table100-body summatable">
                <table>
                  <tr>
                    <td colspan="3" class="cell100">
                      {{ $t("Якуний қолдиқ") }}
                    </td>
                    <td class="cell100 column2 kol">
                      <span :class="{ red: results.end_total < 0 }" v-if="results.end_total!=0">{{
                        results.end_total | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol"></td>
                    <td class="cell100 column2 kol">
                      <span :class="{ red: results.end_total_dollar < 0 }" v-if="results.end_total_dollar!=0">{{
                        results.end_total_dollar | numFormats
                      }}</span>
                    </td>
                    <td class="cell100 column2 kol"></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <kontragent :datas="datas"></kontragent>
    <sklad :datas="datas"></sklad>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
  </b-container>
</template>

<script>
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import { print } from "../../../components/mixins/print.js";
import { Kontragent, Unit, Model, Brand, Colour, Sklad } from "@/pages";
export default {
  components: { Kontragent, Unit, Model, Brand, Colour, Sklad },
  mixins: [print],

  data() {
    return {
      datas: {
        date1: new Date().toISOString().slice(0, 8) + "01",
        date2: new Date().toISOString().slice(0, 10),
        kontragent_id: 0,
        price_type:'dollar',
        sklad_id: parseInt(localStorage.getItem("sklad_id"))
      },
      kontragent: "",
      kontragentlist: [],
      sklad: "",
      skladlist: [],
      errors: "",
      pricelist:[
        {id:'dollar',name:'Доллар'},
        {id:'sum',name:'Cўм'}
      ],
      results: []
    };
  },
  created() {
    let self = this;
    self.$root.$on("kontragentone", function(getdata) {
      self.kontragent = getdata;
    });
    self.$root.$on("kontragentall", function(getdata) {
      self.kontragentlist = getdata;
    });
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    if (this.$route.params.kontragent != 'null') {
      self.datas.date1 = this.$route.params.date1;
      self.datas.date2 = this.$route.params.date2;
      self.datas.sklad_id = parseInt(this.$route.params.sklad);
      self.datas.kontragent_id = parseInt(this.$route.params.kontragent);
      self.datas.price_type = this.$route.params.price;
      self.Send();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (localStorage.getItem("kontragent") != null) {
      localStorage.removeItem("kontragent");
      localStorage.removeItem("date1");
      localStorage.removeItem("date2");
      localStorage.removeItem("sklad_id");
    }
    next();
  },
  methods: {
    Clicked(item){
      let self=this;
      var doc_type=item.doc_type;
      if(item.doc_type=="Возврат поставщик"){
        doc_type="Возврат поставшик";
      }
      let index = this.$router.resolve({ name:doc_type});
      axios({
        method: "post",
        url: "api/v1/users/rule-by-path",
        data: { path: index.route.path}
      }).then(function(response) {
        if(response.data.see==true)
          {
            let routeData = self.$router.resolve({ name:item.doc_type + ' ўзгартириш',params: { id: item.doc_id }});
            window.open(routeData.href, "_blank", "width=1200, height=1000");
          }else{
            self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
          }
      });
    },
    downloadExl() {
      this.$store.state.xls=true;
      setTimeout(() => {
        let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
        wopts = {
          bookType: "xlsx",
          bookSST: false,
          type: "binary"
        };
        var wscols = [{ width: 5 },{ width: 28 },{ width: 20 },{ width: 20 },{ width: 13 },{ width: 13 },{ width: 13 },{ width: 13 }]; 
        wb.Sheets.Sheet1['!cols']=wscols;
        let wbout = XLSX.write(wb, wopts);
      FileSaver.saveAs(
        new Blob([this.s2ab(wbout)], {
          type: "application/octet-stream;charset=utf-8"
        }),
        new Date() + "kontragent_sverka.xlsx"
      );
      setTimeout(() => {
        this.$store.state.xls=false;
      }, 2000);
      }, 2000);
      
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefind") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    // Print() {
    //   let oldstr = window.document.body.innerHTML;
    //   let newstr = document.getElementById("tableId").innerHTML;
    //   window.document.body.innerHTML = newstr;
    //   window.print();
    //   window.document.body.innerHTML = oldstr;
    // },
    Send() {
      let self = this;
      var datas = {
        datetime1: parseInt(
          new Date(self.datas.date1)
            .valueOf()
            .toString()
            .slice(0, 10)
        ),
        datetime2:
          parseInt(
            new Date(self.datas.date2)
              .valueOf()
              .toString()
              .slice(0, 10)
          ) + 86399,
        sklad_id: self.datas.sklad_id,
        kontragent_id: self.datas.kontragent_id,
        price_type: self.datas.price_type,
      };
      axios({
        method: "post",
        url: "api/v1/akt-sverka/kontragent",
        data: datas
      }).then(function(response) {
        self.results = response.data;
        self.results.summ = { kirim_cash: 0,kirim_cash_dollar:0,chiqim_cash_dollar:0, chiqim_cash: 0 };
        self.results.data.forEach(function(key, value) {
          self.results.summ.kirim_cash += parseFloat(key.kirim_summa);
          self.results.summ.kirim_cash_dollar += parseFloat(key.kirim_summa_dollar);
          self.results.summ.chiqim_cash += parseFloat(key.chiqim_summa);
          self.results.summ.chiqim_cash_dollar += parseFloat(key.chiqim_summa_dollar);
        });
      });
    }
  }
};
</script>
<style scoped>
.table100-body {
  max-height: 440px;
}
.my-1{
  padding-right: 10px!important;
}
</style>
